import { APP_BASE_HREF } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AlertService } from 'src/lib/ariadna/alert';
import {
    formatDate,
    formatApiDate,
    formatUiDate,
    formatUiDateTime,
    toDateTime,
} from 'src/app/shared/date/date.utils';
import {
    getNameDay,
    strToDate,
} from '../../components/application/global.function';
import { IPatient } from '../../interfaces/patient.interfaces';
import { IPay, IPaySystemInfo } from '../../interfaces/payment.interfaces';
import {
    IDoctor,
    IResRecord,
    ITalonInfo,
    ITalonModal,
    ITalonResAppointment,
    ITalonResAttrs,
} from '../../interfaces/record.interfaces';

import { ConfigService } from '../../services/application/config.service.';
import { LoadService } from '../../services/application/load.service';
import { PatientService } from '../../services/patient.service';
import { PaymentsService } from '../../services/payments.service';
import { RecordService } from '../../services/record.service';
import { RnumbService } from '../../services/rnumb.service';
import {
    MAX_FILE_SIZE,
    VISIT_ALLOWED_EXTENSIONS,
} from './../../interfaces/constants';

import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { lastValueFrom } from 'rxjs';
import {
    EUploadStatus,
    IAttachedFile,
} from 'src/app/interfaces/document.interfaces';
import { IResponseCreateProtocol } from 'src/app/interfaces/protocol.interfaces';
import { DocInfoModalComponent } from 'src/app/modals/doc-info-modal/doc-info-modal.component';
import { HttpNewService } from 'src/app/services/application/http-new.service';
import { FileUploadService } from 'src/app/services/file-upload.service';
import { ProtocolService } from 'src/app/services/protocol.service';
import { Store } from 'src/app/services/store.service';
import { Utils } from 'src/app/services/utils';

@Component({
    selector: 'app-new-talon-mobile',
    templateUrl: './talon.component.html',
    styleUrls: ['./talon.component.scss'],
    standalone: false,
})
export class NewTalonComponentMobile implements OnInit {
    public page: 'talon' | 'record' | 'pay' | 'cancelOK' | 'goToTeleComp' =
        'talon'; // какую страницу показывать
    public params: ITalonModal | null;
    public talon: ITalonInfo | null = null;
    public rnumbID: number | null;
    // @Input() selectedDoctor: IDoctor | null = null;

    public isResRecord: IResRecord = {
        recTalon: false,
        payOnline: false,
        payClinic: false,
    }; // Есть результат записи
    public payParam: IPay = { phone: '', email: '', sum: 0, abon_id: 0 }; // Оплата
    public _patient: IPatient | null = null;
    public recToPay: boolean = false; // Записаться к врачу на "Оплатить"
    public attrTalonRec: ITalonResAttrs | null = null; // Аттрибуты талона
    public paymentid: number = 0; // Номер платежа
    public confirmationUrl: string = '';
    //  paySystem: IPaySystem = {isPhone: false, isEmail:false, code: '', requiredFieldCodes: []}; // Тип платежной системы
    public paySystem: IPaySystemInfo | null = null; // Тип платежной системы
    public paySystemMode = false;
    public lpuIdsEqual = false;
    public phoneRequiredForPay: boolean = false;
    public emailRequiredForPay: boolean = false;
    public loadingTalon: boolean = false; // Загрузка
    public loadingTalonInfo: boolean = true; //Загрузка информации о талоне
    public cancelingTalon: boolean = false; // Флаг отмены номерка
    public loadingPay: boolean = false; // Флаг загрузки оплаты платежа
    public f_appoitment: boolean = false; // Флаг записи на талон
    public WEB_LK_PAY_LIFETIME = 60; // Время жизни платежа
    public error: string | null = null;
    public getInfoErrorMessage = ''; // Ошибка при получение информации о номерке(Договор на платные услуги)
    public payable: boolean = false;
    public attachedFiles = new Map<string, IAttachedFile>();
    public allowedExt = '';
    public payButtonToUnnesSrv: boolean = false; // принимает параметр, отвечающий за отображ. кнопки оплатить для платных услуг, не обязательных к онлайн оплате
    public patientName: string = '';
    public isMobile: boolean = false;

    public constructor(
        // private window: Window,
        private configS: ConfigService,
        private rs: RecordService,
        private rnumbS: RnumbService,
        private alertService: AlertService,
        private paymentsService: PaymentsService,
        private patientService: PatientService,
        private load: LoadService,
        public dialogRef: MatDialogRef<NewTalonComponentMobile>,
        @Inject(MAT_DIALOG_DATA) public dataIN: ITalonModal,
        private router: Router,
        @Inject(APP_BASE_HREF) private baseHref: string,
        private uploadService: FileUploadService,
        private protocolService: ProtocolService,
        private modalService: NgbModal,
        private httpNew: HttpNewService,
    ) {
        this.params = dataIN;

        this.rnumbID = this.params.rnumbId;
        this.allowedExt = VISIT_ALLOWED_EXTENSIONS.map((ext) => `.${ext}`).join(
            ',',
        );

        if (dataIN.files) this.setFilesFromInput(dataIN.files);

        this.WEB_LK_PAY_LIFETIME =
            load.configData?.GENERAL_PRODUCT_SETTINGS?.PAYMENTS
                .PAYMENT_LIFETIME ?? 60;

        this.payButtonToUnnesSrv =
            !!load.configData?.CLIENT_SETTINGS.OTHER
                .IS_SHOW_PAY_BUTTON_TO_UNNECESSARY_SRV;
    }

    public ngOnInit(): void {
        this.dialogRef.disableClose = true;
        this.dialogRef.backdropClick().subscribe(() => {
            this.closeExit();
        });
        this.dialogRef.keydownEvents().subscribe((event) => {
            if (event.key === 'Escape') {
                event.preventDefault();
                event.stopPropagation();
                this.closeExit();
            }
        });
        window.addEventListener('beforeunload', (event) => {
            const talonBlocks = new Set(
                JSON.parse(localStorage.getItem('talonBlock') || '[]'),
            );
            talonBlocks.add({
                rnumbID: this.params?.rnumbId,
                f_appoitment: this.f_appoitment,
            });

            localStorage.setItem(
                'talonBlock',
                JSON.stringify(Array.from(talonBlocks)),
            );
            talonBlocks.clear();
        });
        this.page = 'talon';

        this.loadingTalonInfo = true;

        if (this.params && this.params.rnumbId) {
            this.getInfo()
                .catch((error) => {
                    this.handlerInfoError(error);
                })
                .finally(() => {
                    this.getPaySystem();
                });
        } else {
            this.getInfoExtra()
                .catch((error) => {
                    this.handlerInfoError(error);
                })
                .finally(() => {});
        }

        const token = Store.getTokenFromCookie();
        Store.getDataString('ParentCookieName')
            ? this.getPatientInfo(true, token!)
            : this.getPatientInfo();

        if (this.dataIN.withUploadFiles) this.setFilesFromDB();

        this.patientService.patientName$.subscribe((patientName) => {
            this.patientName = patientName;
        });

        this.isMobile = window.innerWidth <= 767;
        window.addEventListener('resize', () => {
            this.isMobile = window.innerWidth <= 767;
        });
    }
    public clearEmailForTest() {
        if (this._patient) {
            this._patient.email = '';
        }
        this.payParam.email = '';
    }
    public handlerInfoError(error: any) {
        this.loadingTalonInfo = false;
        const errorMessage = Utils.getErrorMessage(
            error,
            'Не удалось загрузить данные талона',
        );
        this.alertService.warn(errorMessage);
        console.error(errorMessage);
        this.getInfoErrorMessage = errorMessage;
    }
    /* Получить данные по пациенту*/
    public getPatientInfo(isFamilyAccount = false, tokenValue?: string) {
        const result = lastValueFrom(
            this.patientService.getServerPatientInfo$(
                tokenValue,
                isFamilyAccount,
            ),
        );
        result
            .then((info) => {
                this._patient = info;
                this.payParam.email = this._patient.email || '';
                this.payParam.phone =
                    this._patient.cellular || this._patient.phone || '';
            })
            .catch((error) => console.error('getPatientInfo', error));
    }

    /* Получить тип платежной системы телефон почта !*/
    private getPaySystem() {
        this.paymentsService.getPaySystem().then(
            (info) => {
                if (!info.data) {
                    return;
                }
                this.paySystem =
                    info.data?.find(
                        (item) => item.systemLpuId === this.talon?.lpuId,
                    ) ?? (info.data.length === 1 ? info.data[0] : null);
                if (this.paySystem !== null) this.paySystemMode = true;

                if (this.paySystem?.systemLpuId && this.talon?.lpuId) {
                    if (
                        this.paySystem?.systemLpuId === this.talon?.lpuId ||
                        info.data.length === 1
                    )
                        this.lpuIdsEqual = true;
                }
                this.phoneRequiredForPay =
                    this.paySystem?.requiredFields.includes('phone')
                        ? true
                        : false;
                this.emailRequiredForPay =
                    this.paySystem?.requiredFields.includes('email')
                        ? true
                        : false;
                if (
                    this.params?.paramCansel &&
                    (this.params.srv?.isCreatePayOrder ||
                        (this.payButtonToUnnesSrv &&
                            this.params.srv?.isOnlinePay === 1 &&
                            this.paySystemMode &&
                            this.lpuIdsEqual))
                )
                    this.payable = true;
            },
            (err) => {
                console.error('getPaySystem ERR1=', err);
                this.paySystemMode = false;
            },
        );
    }

    public async getInfo() {
        this.loadingTalonInfo = true;
        try {
            if (this.params) {
                const res = await lastValueFrom(
                    this.rs.getRnumbInfo(
                        this.params.rnumbId,
                        this.params?.srv?.keyId.toString(),
                    ),
                );

                if (res && res[0]) {
                    this.talon = res[0];

                    this.talon.beginDate = strToDate(this.talon.datBgn);
                    this.talon.endDate = strToDate(this.talon.datEnd);

                    if (this.params && !this.params.srv) {
                        try {
                            const res = await lastValueFrom(
                                this.rnumbS.getRnumbSrv(this.params?.rnumbId!),
                            );
                            if (res && this.params) {
                                this.params.srv = res;
                            }
                            if (
                                this.params &&
                                this.params.rnumbId &&
                                this.params.srv
                            ) {
                                const attrs = await lastValueFrom(
                                    this.rs.getAttrs(
                                        this.params?.rnumbId,
                                        res.keyId,
                                    ),
                                );
                                if (this.params && this.params.srv) {
                                    this.params.srv.isOnlinePay =
                                        attrs.isOnlinePay;
                                    this.params.srv.isCreatePayOrder =
                                        attrs.isCreatePayOrder;
                                }
                            }
                        } catch (error: any) {
                            console.error(Utils.getErrorMessage(error));
                        }
                    }
                    this.loadingTalonInfo = false;
                }
            }
        } catch (error) {
            console.log(error);
            throw error;
        }
    }

    public async getInfoExtra() {
        try {
            const res = await lastValueFrom(
                this.rs.getRnumbInfoExtra({
                    docdepId: this.params?.info?.docdepID!,
                    date: this.params?.info?.beginDate!,
                    srvIds: this.params?.srv?.keyId.toString()!,
                }),
            );
            // this.talon = res;
            this.loadingTalonInfo = false;
        } catch (error: any) {
            throw error;
        }
    }

    public getImgSrcDoc(id: number | null | undefined): string {
        return `${this.configS.getValue('hostBackend')}/img/doc/${id}.png`;
    }

    /**
     * В случае если изображение на сервере не найдено то грузим локальное изображение
     * @param event
     */
    public errorHandlerIMG(event: any, type: string): void {
        event.target.src = './assets/images/placeholders/doctor-photo.png';
    }

    /* День и время*/
    public getTalonDateTime(dt: Date | undefined, withTime?: boolean): string {
        let str = '';
        if (!dt) return str;
        str = withTime ? formatUiDateTime(dt) : formatUiDate(dt);

        return str;
    }

    // Предиката для определения является ли номерок записью без выбора времени
    // Т.е. если мы передали в модалку rnumbID, и у номерка время исполнения > 3 часов утра, то номерок считается записью без выбора времени
    public withTime(): boolean {
        const date =
            this.talon?.datBgn ||
            formatDate(this.params?.info?.beginDate, 'dd.MM.yyyy HH:mm');

        return (
            Boolean(this.params?.rnumbId) &&
            toDateTime(strToDate(date!)).hour > 3
        );
    }

    /* День недели*/
    public getNameDay(dt: Date | undefined): string {
        if (dt) {
            return getNameDay(dt);
        } else {
            return '';
        }
    }
    public isRecording: boolean = false;

    public async onRecord() {
        this.isRecording = true;
        try {
            if (!this.params) throw new Error('No talon params');
            // инициализация необходимых в функции переменных
            let serviceId: number | null = null;
            let recordResponse: ITalonResAppointment | null = null;
            let createProtResponse: Array<IResponseCreateProtocol>;

            // вытягиваем услугу для записи и сразу заполняем ее цену в this.payParam
            if (this.params.srv) {
                serviceId = +this.params.srv.keyId;
                this.payParam.sum =
                    this.talon?.srvPrice || this.params.srv.price;
            }

            // Осуществляем запись
            if (this.rnumbID) {
                // Обычные номерки
                recordResponse = await lastValueFrom(
                    this.rs.setAppointment(this.rnumbID, serviceId),
                );
                if (!recordResponse)
                    throw new Error('Произошла ошибка при записи');
            } else {
                // Интервальные номерки
                recordResponse = await this.onRecordWithoutRnumbID();
                if (!recordResponse?.rnumbId) {
                    console.error('NO RNUMB ID');
                    this.alertService.error('Запись невозможна');
                    this.dialogRef.close();
                    return;
                }
                this.rnumbID = recordResponse.rnumbId;
            }
            this.f_appoitment = true; // заполнили флаг, что запись осуществилась

            // Заполняем параметр прикрепленных файлов, если они есть
            if (recordResponse.withUploadFiles) {
                this.params.withUploadFiles = !!recordResponse.withUploadFiles;
            }
            if (recordResponse.tag && recordResponse.linkId) {
                this.params.tag = recordResponse.tag;
                this.params.link_id = recordResponse.linkId;
            }

            // Если после записи вернулся идентификатор формы, создаем анкету и заполняем параметры для отображения
            if (recordResponse.formId) {
                createProtResponse = await lastValueFrom(
                    this.protocolService.createProtocol(
                        recordResponse.visitId,
                        recordResponse.formId,
                    ),
                );
                this.params.form_result_id = createProtResponse[0].identity;
                this.params.visit_id = recordResponse.visitId;
            }

            // Вызов атрибутов номерка, если к нему прикреплена услуга (всегда)
            if (this.params.srv) {
                const attrs = await lastValueFrom(
                    this.rs.getAttrs(this.rnumbID, serviceId),
                );
                this.params.srv.isOnlinePay = attrs.isOnlinePay;
                this.params.srv.isCreatePayOrder = attrs.isCreatePayOrder;
                this.attrTalonRec = attrs;
                this.recToPay = true;
                // После вызова атрибутов, проверяем по ним, надо ли создавать отложенный и отображать кнопку оплатить
                // Если она обязательная к онлайн-оплате ИЛИ не обязательная, но платная, и платежка доступна
                if (
                    attrs.isCreatePayOrder === 1 ||
                    (this.payButtonToUnnesSrv &&
                        attrs.isOnlinePay === 1 &&
                        this.paySystemMode &&
                        this.lpuIdsEqual)
                ) {
                    if (attrs.isTelemed === 1) {
                        // Если телемедицина(именно в блоке платно), отправляем запрос на создание конференции
                        await lastValueFrom(
                            this.rs.getСreateConference(this.rnumbID),
                        );
                    }
                    // создаем отложенный
                    const resCPbyR = await lastValueFrom(
                        this.rs.getCPbyR(this.rnumbID, serviceId),
                    );
                    if (!resCPbyR.paymentId)
                        throw new Error('Не удалось создать платеж');

                    this.paymentid = resCPbyR.paymentId;
                    // После всех манипуляций для платных
                    this.payable = true; // переводим флаг на то, чтоб отобразить внизу окна кнопку оплаты
                    this.isRecording = false; // прячем спиннер
                } else {
                    this.page = 'record';
                    this.isResRecord.recTalon = true;
                    this.isRecording = false;
                }
            }
        } catch (error) {
            this.isRecording = false;
            console.log((error as Error).message);
            this.handleError(error);
        }
    }

    public async onRecordWithoutRnumbID() {
        return await lastValueFrom(
            this.rs.setAppointmentExtra(
                this.params?.info?.docdepID!,
                this.params?.srv?.keyId.toString()!,
                formatApiDate(this.params?.info?.beginDate),
            ),
        );
    }
    // async createProtocol(visitId: number, formId: number) {
    //     return await lastValueFrom(
    //         this.protocolService.createProtocol(visitId, formId),
    //     );
    // }

    private async handleError(error: any) {
        if (this.params?.rnumbId && this.f_appoitment) {
            try {
                await lastValueFrom(
                    this.rs.getRnumbCancel(this.params?.rnumbId),
                );
            } catch (error: any) {
                console.error(
                    'Проблема с отменой записи на талон:',
                    Utils.getErrorMessage(error),
                );
            }
        }
        this.alertService.error(Utils.getErrorMessage(error));
        this.dialogRef.close({
            rnumbID: this.rnumbID,
            unlockTalon: true,
        });
    }

    public onCancelPage() {
        this.page = 'cancelOK';
    }
    public onClickPopTelemed() {
        this.page = 'goToTeleComp';
    }
    public onCancelRecord() {
        if (this.params && this.params.rnumbId) {
            this.cancelingTalon = true;
            lastValueFrom(this.rs.getRnumbCancel(this.params.rnumbId))
                .then(() => {
                    this.alertService.success('Талон успешно отменен.', 4000);
                    this.dialogRef.close({
                        rnumbID: this.params?.rnumbId,
                        cancelRes: true,
                    });
                    this.cancelingTalon = false;
                })
                .catch((errCanc) => {
                    this.dialogRef.close();
                    this.alertService.error(
                        Utils.getErrorMessage(errCanc),
                        7000,
                    );
                    console.error('getRnumbCancel ERRROr=', errCanc);
                    this.cancelingTalon = false;
                });
        } else {
            // this.alertService.error('Нет номерка.')
            this.showError('Нет номерка.');
        }
    }
    public async goToPay(): Promise<void> {
        if (this.loadingPay) return;
        if (!this.paySystemMode) {
            this.alertService.info(
                'Для данного учреждения не определена платежная система. Онлайн-оплата невозможна',
            );
            throw new Error('Онлайн-оплата невозможна');
        }
        this.page = 'pay';
        this.loadingPay = true;
        try {
            const service = this.params?.srv;
            if (!service) throw new Error('Нет услуги, нечего оплачивать.');
            this.payParam.sum = this.talon?.srvPrice || service.price;
            if (service.paymentId) this.paymentid = service.paymentId;
            if (service.confirmationUrl)
                this.confirmationUrl = service.confirmationUrl;

            if (!this.paymentid && !this.confirmationUrl) {
                if (!this.rnumbID)
                    throw new Error('Оплата невозможна, нет номерка.');
                await this.ensurePaymentId(this.rnumbID, service.keyId);
            }
        } catch (error: unknown) {
            this.showError(
                Utils.getErrorMessage(error, 'Ошибка при создании платежа.'),
            );
        } finally {
            this.loadingPay = false;
        }
    }

    public async goPay(): Promise<void> {
        if (this.loadingPay) return;

        if (!this.rnumbID) {
            this.alertService.error('Оплата невозможна, нет номерка.');
            return;
        }

        const service = this.params?.srv;
        if (!service) {
            this.showError('Нет услуги, нечего оплачивать.');
            return;
        }

        this.loadingPay = true;
        let paymentWindow: Window | null = null;

        try {
            if (service.isOnlinePay !== 1) {
                if (!this.paymentid) {
                    this.showError('Отсутствует идентификатор платежа.');
                    return;
                }
                await lastValueFrom(
                    this.rs.getPaymentTemp(
                        this.paymentid,
                        this.payParam.email,
                        this.payParam.phone,
                    ),
                );
                return;
            }
            if (this.confirmationUrl) {
                this.openPayWindow(this.confirmationUrl);
                return;
            }

            const paymentId = await this.ensurePaymentId(
                this.rnumbID,
                service.keyId,
            );
            const confirmationUrl = await this.createConfirmationUrl(paymentId);
            this.confirmationUrl = confirmationUrl;
            paymentWindow = this.openPendingPayWindow();
            this.openPayWindow(confirmationUrl, paymentWindow);
        } catch (error: unknown) {
            if (paymentWindow && !paymentWindow.closed) paymentWindow.close();
            this.showError(
                Utils.getErrorMessage(
                    error,
                    'Ошибка создания платежа, попробуйте повторить операцию позднее.',
                ),
            );
            console.error(
                `Не удалось открыть платежную страницу: ${Utils.getErrorMessage(error)}`,
            );
        } finally {
            this.loadingPay = false;
        }
    }

    private async ensurePaymentId(
        rnumbId: number,
        serviceId: number,
    ): Promise<number> {
        if (this.paymentid) return this.paymentid;

        const payment = await lastValueFrom(
            this.rs.getCPbyR(rnumbId, serviceId),
        );
        if (!payment.paymentId)
            throw new Error('Ошибка при создании платежа, не получили ID.');

        this.paymentid = payment.paymentId;
        return this.paymentid;
    }

    private async createConfirmationUrl(paymentId: number): Promise<string> {
        const payment = await lastValueFrom(
            this.rs.getPaymentTemp(
                paymentId,
                this.payParam.email,
                this.payParam.phone,
            ),
        );
        if (!payment.identity || payment.identity <= 0)
            throw new Error('Не удалось создать платеж');

        const payOrder = await lastValueFrom(
            this.paymentsService.getPayOrder(payment.identity),
        );
        if (!payOrder.confirmationUrl)
            throw new Error(
                'Не получилось создать платеж в платежной системе.',
            );

        return payOrder.confirmationUrl;
    }

    private openPendingPayWindow(): Window | null {
        if (this.isSafari()) return null;

        const paymentWindow = window.open('about:blank', '_blank');
        if (paymentWindow) paymentWindow.opener = null;
        return paymentWindow;
    }

    private isSafari(): boolean {
        return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    }

    public openPayWindow(
        confirmationUrl: string,
        paymentWindow: Window | null = null,
    ): void {
        if (!confirmationUrl.trim())
            throw new Error('Платежная система не вернула ссылку на оплату.');

        if (this.isSafari()) {
            if (paymentWindow && !paymentWindow.closed) paymentWindow.close();
            window.location.href = confirmationUrl;
            return;
        }

        if (paymentWindow && !paymentWindow.closed) {
            paymentWindow.location.href = confirmationUrl;
        } else {
            const openedWindow = window.open(confirmationUrl, '_blank');
            if (!openedWindow) {
                window.location.href = confirmationUrl;
                return;
            }
            openedWindow.opener = null;
        }

        this.dialogRef.close();
    }

    public validPay(): boolean {
        const emailValid =
            !this.emailRequiredForPay ||
            (this.payParam.email && this.payParam.email.includes('@'));
        const phoneValid =
            !this.phoneRequiredForPay ||
            (this.payParam.phone &&
                this.payParam.phone.replace(/\D/g, '').length >= 10);

        return !(emailValid && phoneValid);
    }
    public getPayErrorMessage(): string {
        if (!this.paySystem) return '';

        const emailFilled =
            this.payParam.email && this.payParam.email.includes('@');
        const phoneFilled =
            this.payParam.phone &&
            this.payParam.phone.replace(/\D/g, '').length >= 11;

        if (this.emailRequiredForPay && !emailFilled) {
            return 'Введите корректный email для оплаты.';
        }

        if (this.phoneRequiredForPay && !phoneFilled) {
            return 'Введите корректный номер телефона для оплаты.';
        }

        return '';
    }

    public setSumm(): number | null {
        if (this.talon && this.talon.srvPrice) {
            return this.talon.srvPrice;
        } else if (this.params && this.params.srv && this.params.srv.price) {
            return this.params.srv.price;
        } else {
            return null;
        }
    }

    public getFIODoc(talon: ITalonInfo | null): string {
        let s = '';
        if (talon) {
            if (talon.lastName && talon.lastName.length > 0) {
                s = talon.lastName;
            }
            if (talon.firstName && talon.firstName.length > 0) {
                s = s + ' ' + talon.firstName;
            }
            if (talon.secondName && talon.secondName.length > 0) {
                s = s + ' ' + talon.secondName;
            }
        }
        return s;
    }

    public closeExit() {
        if (this.f_appoitment === true) {
            // Запись уже осуществилась
            this.dialogRef.close({
                rnumbID: this.params?.rnumbId,
                unlockTalon: false,
            }); // Закрываем
        } else {
            this.dialogRef.close({
                rnumbID: this.params?.rnumbId,
                unlockTalon: true,
            }); // Закрываем
        }
    }

    // Переход на телевидеоКонференцию
    public goToTelemed(talon: ITalonInfo | null) {
        if (talon && talon.urlTelemed && talon.urlTelemed.length > 5) {
            window.open(talon.urlTelemed, '_blank');
        }
    }

    public showError(text: string) {
        this.error = text;
    }

    public hideError() {
        this.error = null;
    }

    public toPayments(event: MouseEvent) {
        event.preventDefault();
        this.router.navigate([`/home/payments`]);
        this.dialogRef.close();
    }

    public toHistory(event: MouseEvent) {
        event.stopPropagation();
        this.router.navigate([`/home/history`]);
        this.dialogRef.close();
    }

    public toRecord(event: MouseEvent) {
        event.stopPropagation();
        this.router.navigate([`/home/record-services`]);
        if (this.router.url.includes('record-services')) {
            this.router.navigate(['/home/record-services']);
        } else {
            this.router.navigate(['/home/rec']);
        }

        this.dialogRef.close();
    }

    public onDrop(event: DragEvent) {
        event.preventDefault();
        const { dataTransfer } = event;
        if (!dataTransfer) return;

        const filelist = new DataTransfer();

        if (dataTransfer.items) {
            for (let i = 0; i < dataTransfer.items.length; i++) {
                if (dataTransfer.items[i].kind === 'file') {
                    const file = dataTransfer.items[i].getAsFile();
                    if (!file) continue;
                    filelist.items.add(file);
                }
            }
            this.setFilesFromInput(filelist.files);
            filelist.items.clear();
            dataTransfer.items.clear();
        }
    }

    public async uploadFile(file: File, tag: number, id: number) {
        try {
            const res = await this.uploadService.uploadFile(file, tag, id);
            if (!res?.id) {
                throw new Error(`Не удалось сохранить файл ${file.name}`);
            }
            this.attachedFiles.set(file.name, {
                ...this.attachedFiles.get(file.name)!,
                id: Number(res?.id),
                status: EUploadStatus.SUCCESS,
                link_id: res?.id,
                storage_path: res.storagePath ?? '',
            });
        } catch (error: any) {
            this.alertService.error(
                `Не удалось сохранить файл ${file.name} \n ${Utils.getErrorMessage(error)}`,
            );
            this.deleteFile(file.name, id);
        }
    }

    public async deleteFile(name: string, id: number) {
        this.attachedFiles.set(name, {
            ...this.attachedFiles.get(name)!,
            status: EUploadStatus.LOADING,
        });

        if (this.attachedFiles.get(name)) {
            const response = await this.uploadService.deleteFileFromDB(
                this.attachedFiles.get(name)?.storage_path || undefined,
                id.toString(),
            );
            if (response) {
                this.attachedFiles.set(name, {
                    ...this.attachedFiles.get(name)!,
                    status: EUploadStatus.SUCCESS,
                });
            } else {
                this.attachedFiles.set(name, {
                    ...this.attachedFiles.get(name)!,
                    status: EUploadStatus.ERROR,
                });
            }
        }

        this.attachedFiles.delete(name);
    }

    public deleteFileHandler(event: Event, name: string, id: number) {
        event.stopPropagation();
        event.preventDefault();
        this.deleteFile(name, id);
    }

    public getExt(name: string): string {
        return name.split('.').pop() ?? '';
    }

    public onChangeInputUpload(event: Event) {
        const target = event.target as HTMLInputElement;
        const files = target.files;

        if (!files) {
            console.log('NO FILES IN INPUT');
            return;
        }

        this.setFilesFromInput(files);
    }

    public async setFilesFromInput(files: FileList) {
        for (let i = 0; i < files.length; i++) {
            const file = files[i];
            if (!file) continue;
            const ext = this.getExt(file.name);
            const name = file.name.substring(0, file.name.indexOf(`.${ext}`));

            if (!VISIT_ALLOWED_EXTENSIONS.includes(ext)) {
                this.alertService.warn(
                    `Файл ${file.name} имеет неподходящее расширение`,
                );
                continue;
            }

            if (file.size >= MAX_FILE_SIZE) {
                this.alertService.warn(`Файл ${file.name} силшком большой!`);
                continue;
            }

            if (this.attachedFiles.has(file.name)) {
                this.alertService.warn(
                    `${file.name} уже существует в базе или загружется сейчас`,
                );
                continue;
            }

            this.attachedFiles.set(file.name, {
                file,
                ext,
                name,
                status: EUploadStatus.LOADING,
                id: null,
                link_id: null,
                storage_path: '',
            });
            console.log(files[i], this.params?.tag, this.params?.link_id); // ЗДЕСЬ ПРОБЛЕМА НАфиг!!!!!!!!!!!!!!!
            this.uploadFile(files[i], this.params?.tag!, this.params?.link_id!);
        }
    }

    // Get already uploaded files from db and set to attacheFiles
    public async setFilesFromDB() {
        const filelist = await this.uploadService.getFilelist(
            this.params?.tag!,
            this.params?.link_id!,
        );

        filelist.forEach((file) => {
            this.attachedFiles.set(`${file.name}${file.fileType}`, {
                name: file.name,
                id: file.id,
                ext: file.fileType,
                status: EUploadStatus.SUCCESS,
                link_id: this.params?.link_id!,
                storage_path: file.storage_path || '',
            });
        });
    }

    public stopPropagation(e: MouseEvent) {
        e.stopPropagation();
    }

    public onDragOver(event: any) {
        event.stopPropagation();
        event.preventDefault();
    }

    public payLater() {
        this.page = 'record';
    }

    public openDocInfoModal(event: Event) {
        event.stopPropagation();

        const doctor: Partial<IDoctor> = {
            doctorId: this.talon?.doctorId as number,
            lName: this.talon?.lastName as string,
            fName: this.talon?.firstName as string,
            sName: this.talon?.secondName as string,
            infoDoc: this.params?.infoDoc,
        };
        const modal = this.modalService.open(DocInfoModalComponent);

        modal.componentInstance.doc = doctor;
        modal.componentInstance.spec = this.talon?.spec;
    }

    public formatPhone(phone: string | null | undefined): string {
        if (!phone) return '';
        const cleaned = phone.replace(/\D/g, '');
        const part1 = cleaned.slice(0, 1);
        const part2 = cleaned.slice(1, 4);
        const part3 = cleaned.slice(4);
        return `+${part1} (${part2}) ${part3.slice(0, 3)}-${part3.slice(
            3,
            5,
        )}-${part3.slice(5, 7)}`;
    }

    public getFullName(talon: ITalonInfo | null): string {
        const lastName = talon?.lastName ?? '';
        const firstName = talon?.firstName ?? '';
        const secondName = talon?.secondName ?? '';

        return `${lastName} ${firstName} ${secondName}`.trim();
    }
    public onVisitProtocolClick(e: MouseEvent) {
        e.stopPropagation();
        this.dialogRef.close();
        this.router.navigate([
            `home/visit-protocol/${this.params?.visit_id}/${this.params?.form_result_id}`,
        ]);
    }
    public modalReference!: NgbModalRef;
    public canChangeEmail = false;
    public newEmail: string = '';
    public openModal(e: Event, content: any) {
        if (!this.canChangeEmail) {
            return;
        }
        e.stopPropagation();

        this.modalReference = this.modalService.open(content);
    }
    public closeModal() {
        this.modalReference.close();
    }

    public get hasDoctorInfo(): boolean {
        return (
            Array.isArray(this.params?.infoDoc) &&
            this.params.infoDoc.length > 0
        );
    }

    public showRubSvg(): boolean {
        if (this.params?.srv?.isCreatePayOrder === 1) return true;
        else return false;
    }
}
